import React from 'react';
import { Route, Redirect } from 'react-router';
import { useAuthContext } from '../context';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { authUser, deviceRegistryStatus } = useAuthContext();
  const registryResult = deviceRegistryStatus?.results || deviceRegistryStatus;
  const requiresDeviceApproval = registryResult?.accessAllowed === false;
  const isDeviceApprovalRoute = rest.path === '/device-approval';

  return (
    <Route
      {...rest}
      render={(props) =>
        authUser && requiresDeviceApproval && !isDeviceApprovalRoute ? (
          <Redirect to="/device-approval" />
        ) : authUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/sign-in',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
